import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { env } from '@campai/lib-web/env'

import { appState } from '@/appState'
import { Page } from '@/components/Page'

import { DangerZone } from './DangerZone'
import { Notifications } from './Notifications'
import { Personal } from './Personal'
import { Preferences } from './Preferences'
import { Security } from './Security'

export const UserProfile = observer(() => {
    const { t } = useTranslation()
    const showSecuritySettings = env.VITE_AUTH_PROVIDER === 'authy' || appState.user.authProviders.includes('blueid')

    return (
        <Page title={t('profile.title')} headerClassName="mx-auto w-full max-w-3xl">
            <div className="mx-auto w-full max-w-3xl space-y-4">
                <Personal />
                {showSecuritySettings && <Security />}
                <Preferences />
                <Notifications />
                <DangerZone />
            </div>
        </Page>
    )
})
